import { render, staticRenderFns } from "./IndicadoresCapacidadeProdutiva.vue?vue&type=template&id=2d4469fa&scoped=true&lang=pug"
import script from "./IndicadoresCapacidadeProdutiva.vue?vue&type=script&lang=js"
export * from "./IndicadoresCapacidadeProdutiva.vue?vue&type=script&lang=js"
import style0 from "./IndicadoresCapacidadeProdutiva.vue?vue&type=style&index=0&id=2d4469fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4469fa",
  null
  
)

export default component.exports